import React, { useEffect, useState } from "react";
import {
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  FormControlLabel,
  TablePagination,
  Tooltip,
  FormControl,
  Radio,
  RadioGroup,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import {
  useGetActualCountQuery,
  useGetAllClickerCampaignQuery,
  useGetClickerCountNumberQuery,
  useGetscheduledataQuery,
  useGetclickercountdetailQuery,
  useDownloadClickerReportMutation,
  useDownloadClickerReportByDateMutation,
  useDownloadCampaignReportByDateMutation,
  useDownloadClickerCountReportMutation,
  useGetClickerClickListQuery,
  useDownloadClickerClickListMutation,
} from "../store/services/clickerApi";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import { layoutCSS } from "../component/common/commonStyle";
import { useDeleteRowDataMutation } from "../store/services/clickerApi";
import { toast } from "react-toastify";
import { useGetCustomerServiceQuery } from "../store/services/resellerApi";
import { useGetCustomerLogDeleteKeyQuery } from "../store/services/reportApi";

// Bulk input field styles (consistent with WorkFlow)
const inputSx = {
  "& .MuiOutlinedInput-root": {
    background: "rgba(255, 255, 255, 0.45)",
    "& fieldset": { borderColor: "#E2E8F0" },
    "&:hover fieldset": { borderColor: "#94A3B8" },
  },
  "& .MuiInputLabel-root": { color: "#9333ea !important" },
  "& .MuiInputLabel-root.Mui-disabled": { color: "#9333ea !important" },
  "& .Mui-disabled": {
    "& .MuiOutlinedInput-input": {
      color: "#334155 !important",
      WebkitTextFillColor: "#334155 !important",
    },
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#CBD5E1" },
  },
};

const selectSx = {
  background: "rgba(255,255,255,0.9)",
  "& .Mui-disabled": {
    color: "#334155 !important",
    WebkitTextFillColor: "#334155 !important",
  },
  "&.Mui-disabled .MuiOutlinedInput-notchedOutline": { borderColor: "#CBD5E1" },
};

const ManageCampaign = () => {
  const navigate = useNavigate();

  const maskPhoneNumber = (phone) => {
    if (!phone) return "";
    if (phone.length <= 8) return phone;
    const start = phone.slice(0, phone.length - 8);
    const end = phone.slice(-4);
    return `${start}XXXX${end}`;
  };

  const todayStr = () => new Date().toISOString().slice(0, 10);
  const [fromDate, setFromDate] = useState(todayStr());
  const [toDate, setToDate] = useState(todayStr());
  const maxDate = todayStr();
  const { data: scheduleData } = useGetscheduledataQuery();
  const [showSchedule, setShowSchedule] = useState(false);
  const [clickListPopupOpen, setClickListPopupOpen] = useState(false);
  const [clickListPage, setClickListPage] = useState(0);
  const [clickListRowsPerPage, setClickListRowsPerPage] = useState(25);
  const [downloadClickerClickList] = useDownloadClickerClickListMutation();
  const [reportType, setReportType] = useState("all");
  const { data: getALLData, refetch } = useGetAllClickerCampaignQuery(
    {
      from: fromDate,
      to: toDate,
      ...(reportType !== "all" && { type: reportType }),
    },
    { refetchOnMountOrArgChange: true },
  );

  const [popupOpen, setPopupOpen] = useState(false);
  const [ActualpopupOpen, setActualpopupopen] = useState(false);
  const [detailPopupOpen, setDetailPopupOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedShortCodeForDetail, setSelectedShortCodeForDetail] =
    useState(null);
  const [selectedPhoneForDetail, setSelectedPhoneForDetail] = useState(null);
  const [downloadClickerCountReport] = useDownloadClickerCountReportMutation();
  const [downloadCampaignReportByDate] =
    useDownloadCampaignReportByDateMutation();
  useEffect(() => {
    refetch();
  }, [refetch]);
  useEffect(() => {
    if (toDate < fromDate) setToDate(fromDate);
  }, [fromDate, toDate]);
  useEffect(() => {
    refetch();
  }, [fromDate, toDate, reportType, refetch]);
  const [page, setPage] = useState(0);
  const [modelPage, setModelPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [deleteRowData] = useDeleteRowDataMutation();
  const { data: getActualCount } = useGetActualCountQuery(
    {
      clicker_campaign_id: selectedRowId,
      page: page + 1,
    },
    {
      skip: !ActualpopupOpen || !selectedRowId,
    },
  );

  const { data: featureKeyData } = useGetCustomerLogDeleteKeyQuery();

  const showMobileNumber = featureKeyData?.data?.show_mobile_number ?? false;
  const { data: getClickerCountNumber } = useGetClickerCountNumberQuery(
    {
      type: reportType,
      clicker_campaign_id: selectedRowId,
      page: modelPage + 1,
      limit: rowsPerPage,
    },
    {
      skip: !popupOpen || !selectedRowId,
    },
  );
  const [downloadClickerReport] = useDownloadClickerReportMutation();

  const { data: clickerDetailsData, isLoading: isDetailsLoading } =
    useGetclickercountdetailQuery(
      {
        short_code: selectedShortCodeForDetail,
        type: reportType,
      },
      {
        skip: !detailPopupOpen || !selectedShortCodeForDetail,
      },
    );

  const { data: serviceResp, isLoading: isServiceLoading } =
    useGetCustomerServiceQuery();
  const { data: clickerClickListData, isLoading: isClickListLoading } =
    useGetClickerClickListQuery(
      {
        clicker_campaign_id: selectedRowId,
        type: reportType,
        page: clickListPage + 1,
        limit: clickListRowsPerPage,
      },
      {
        skip: !clickListPopupOpen || !selectedRowId,
      },
    );
  const [downloadClickerReportByDate] =
    useDownloadClickerReportByDateMutation();

  const hasServices = !isServiceLoading && (serviceResp?.data?.length ?? 0) > 0;

  const handleDelete = async (id) => {
    try {
      await deleteRowData(id).unwrap();
      toast.success(`Row with id ${id} deleted successfully`, {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (error) {
      toast.error(" Failed to delete row", {
        position: "top-right",
        autoClose: 3000,
      });
      console.error("Failed to delete row: ", error);
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenPopup = (id) => {
    setSelectedRowId(id);
    setModelPage(0);
    setPopupOpen(true);
  };
  const handleOpenClickListPopup = (id) => {
    setSelectedRowId(id);
    setClickListPage(0);
    setClickListPopupOpen(true);
  };

  const handleCloseClickListPopup = () => {
    setSelectedRowId(null);
    setClickListPage(0);
    setClickListPopupOpen(false);
  };
  const handleActualOpenPopup = (id) => {
    setSelectedRowId(id);
    setActualpopupopen(true);
  };
  const handleActualClosePopup = () => {
    setSelectedRowId(null);
    setActualpopupopen(false);
  };

  const handleClosePopup = () => {
    setSelectedRowId(null);
    setModelPage(0);
    setPopupOpen(false);
  };

  const handleOpenDetailPopup = (shortcode, ph_no) => {
    setSelectedShortCodeForDetail(shortcode);
    setSelectedPhoneForDetail(ph_no);
    setDetailPopupOpen(true);
  };

  const handleCloseDetailPopup = () => {
    setSelectedShortCodeForDetail(null);
    setSelectedPhoneForDetail(null);
    setDetailPopupOpen(false);
  };

  if (!isServiceLoading && !hasServices) {
    return (
      <Box
        sx={{
          textAlign: "center",
          mt: 10,
          fontSize: "1rem",
        }}
      >
        <Typography variant="h6" color="error">
          You have not been assigned any service. Please contact your
          administrator.
        </Typography>
      </Box>
    );
  }

  const rows = showSchedule ? scheduleData?.data || [] : getALLData?.data || [];

  const inputSx = {
    borderRadius: "0.5rem",
    minWidth: 140,
    "& .MuiOutlinedInput-root": {
      background: "rgba(255,255,255,0.7)",
      "& fieldset": { borderColor: "#E2E8F0" },
      "&:hover fieldset": { borderColor: "#94A3B8" },
    },
    "& .MuiInputLabel-root": { color: "#475569" },
    "& .Mui-disabled": {
      "& .MuiOutlinedInput-input": {
        color: "#334155 !important",
        WebkitTextFillColor: "#334155 !important",
      },
      "& .MuiOutlinedInput-notchedOutline": { borderColor: "#CBD5E1" },
    },
  };
  return (
    <Box sx={layoutCSS}>
      <Typography sx={{ mb: 3 }} variant="h6">
        Manage Campaign
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 1,
          flexWrap: "wrap",
          alignItems: "center",
          borderRadius: "0.5rem",
          padding: "1rem",
          backgroundColor: "#ffffff52",
          backdropFilter: "blur(10px)",
          boxShadow: "0 4px 12px rgba(14,165,233,0.1)",
        }}
      >
        {/* Date inputs – left side */}
        <TextField
          label="From"
          size="small"
          type="date"
          value={fromDate}
          inputProps={{ max: maxDate }}
          onChange={(e) => setFromDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={inputSx}
        />
        <TextField
          label="To"
          size="small"
          type="date"
          value={toDate}
          inputProps={{ max: maxDate, min: fromDate }}
          onChange={(e) => setToDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={inputSx}
        />

        {/* Spacer – pushes everything after to the right */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Buttons – right side */}
        <Button
          size="small"
          variant="contained"
          color="primary"
          sx={{
            fontSize: "0.7rem",
            padding: "6px 10px",
            textTransform: "none",
          }}
          onClick={async () => {
            if (!fromDate || !toDate) {
              toast.error("Please select both dates");
              return;
            }

            try {
              const blob = await downloadCampaignReportByDate({
                startdate: fromDate,
                enddate: toDate,
                type: reportType,
              }).unwrap();

              const url = window.URL.createObjectURL(blob);

              const a = document.createElement("a");

              a.href = url;

              a.download = `Campaign_Report_${reportType}_${fromDate}_to_${toDate}.csv`;

              document.body.appendChild(a);

              a.click();

              document.body.removeChild(a);

              window.URL.revokeObjectURL(url);

              toast.success("Report Downloaded Successfully");
            } catch (err) {
              console.error("Download Error:", err);

              const errorMessage =
                err?.data?.message || err?.error || "No data found";

              toast.error(errorMessage);
            }
          }}
        >
          ⬇ Download
        </Button>

        <Button
          size="small"
          onClick={() => navigate("/createcampaign")}
          variant="contained"
          color="secondary"
          sx={{
            fontSize: "0.7rem",
            padding: "6px 10px",
            textTransform: "none",
          }}
        >
          Create Campaign
        </Button>
      </Box>
      {/* Checkboxes */}
      <Box
        display="flex"
        justifyContent="space-between"
        mt={3}
        alignItems="center"
      >
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="outlined"
            size="small"
            sx={{
              minWidth: "100px",
              fontSize: "0.7rem",
              backgroundColor: showSchedule ? "transparent" : "#0288d1",
              color: showSchedule ? "inherit" : "#fff",
            }}
            onClick={() => setShowSchedule(false)}
          >
            All Logs
          </Button>

          <Button
            variant="outlined"
            size="small"
            sx={{
              minWidth: "100px",
              fontSize: "0.7rem",
              backgroundColor: showSchedule ? "#0288d1" : "transparent",
              color: showSchedule ? "#fff" : "inherit",
            }}
            onClick={() => setShowSchedule(true)}
          >
            Schedule Date
          </Button>
        </Box>
        <Box>
          <FormControl>
            <RadioGroup
              row
              name="reportType"
              value={reportType}
              onChange={(e) => setReportType(e.target.value)}
            >
              <FormControlLabel
                value="all"
                control={<Radio />}
                label="All Reports"
              />
              <FormControlLabel
                value="actual"
                control={<Radio />}
                label="Actual Reports"
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </Box>

      {/* Main Table */}

      <TableContainer background="rgba(255, 255, 255, 0)">
        <Table size="small">
          <TableHead sx={{ background: "#0288d1" }}>
            <TableRow>
              {[
                "Date",
                "Campaign Name",
                "Sender ID",
                "Clicker Text",
                "File Count",
                "clicker count",
              ].map((header, idx, arr) => (
                <TableCell
                  key={header}
                  sx={{
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    color: "white",
                    textAlign: "center",
                    borderRight:
                      idx < arr.length - 1 ? "0.5px solid #3a3a3a" : "none",
                  }}
                >
                  {header}
                </TableCell>
              ))}
              {showSchedule && (
                <TableCell
                  sx={{
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  Action
                </TableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody sx={{ background: "rgba(255, 255, 255, 0.36)" }}>
            {rows.length > 0 ? (
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow key={index}>
                    <TableCell
                      sx={{
                        borderRight: "0.5px solid #3a3a3a",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {row?.time_to_send ? (
                        <>
                          {new Date(row.time_to_send).toLocaleDateString(
                            "en-GB",
                          )}
                          <br />
                          {new Date(row.time_to_send).toLocaleTimeString(
                            "en-GB",
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: "0.5px solid #3a3a3a",
                        textAlign: "center",
                      }}
                    >
                      {row?.campaignname}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: "0.5px solid #3a3a3a",
                        textAlign: "left",
                      }}
                    >
                      <Tooltip title={row?.header_name || ""} arrow>
                        <span>{row?.header_name || ""}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: "0.5px solid #3a3a3a",
                        textAlign: "left",
                      }}
                    >
                      <Tooltip title={row?.smstext || ""} arrow>
                        <span>{`${row?.smstext?.substring(0, 60)}...`}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: "0.5px solid #3a3a3a",
                        textAlign: "center",
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                      }}
                      onClick={() => handleOpenPopup(row?.clicker_campaign_id)}
                    >
                      {row?.total_numbers || 0}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: showSchedule
                          ? "0.5px solid #3a3a3a"
                          : "none",
                        textAlign: "center",
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                      }}
                      onClick={() =>
                        handleOpenClickListPopup(row?.clicker_campaign_id)
                      }
                    >
                      {reportType === "actual"
                        ? row?.actual_clicks || row?.total_clicks || 0
                        : row?.total_clicks || 0}
                    </TableCell>
                    {showSchedule && (
                      <TableCell
                        align="center"
                        sx={{ background: "rgba(255, 255, 255, 0.36)" }}
                      >
                        <EditIcon
                          onClick={() =>
                            navigate(
                              `/createcampaign/${row?.clickersmsUpload_id}`,
                            )
                          }
                          sx={{
                            color: "#1976d2",
                            opacity: 0.5,
                            cursor: "pointer",
                          }}
                        />
                        <DeleteForeverIcon
                          sx={{ cursor: "pointer", color: "#1976d2", ml: 1 }}
                          onClick={() => handleDelete(row.clickersmsUpload_id)}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 2 }}>
                  No Data Found!
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={rows.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[10, 25, 50]}
      />

      {/* Clicker Numbers Dialog */}
      <Dialog
        open={popupOpen}
        onClose={handleClosePopup}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: "#0288d1",
            color: "#fff",
            fontWeight: 600,
            fontSize: "1.1rem",
          }}
        >
          Clicker Numbers
        </DialogTitle>
        <DialogContent sx={{ p: 2 }}>
          <Box mb={1}>
            <Typography variant="subtitle2" color="text.secondary">
              Showing clicker details with pagination
            </Typography>
            <Button
              variant="contained"
              size="small"
              onClick={async () => {
                try {
                  const blob = await downloadClickerCountReport({
                    clicker_campaign_id: selectedRowId,
                    type: reportType,
                  }).unwrap();

                  const url = window.URL.createObjectURL(blob);

                  const a = document.createElement("a");

                  a.href = url;

                  a.download = `Clicker_Count_Report_${selectedRowId}.csv`;

                  document.body.appendChild(a);

                  a.click();

                  document.body.removeChild(a);

                  window.URL.revokeObjectURL(url);

                  toast.success("Report Downloaded Successfully");
                } catch (err) {
                  console.error(err);

                  toast.error(
                    err?.data?.message || "Failed to download report",
                  );
                }
              }}
            >
              ⬇ Download CSV
            </Button>
          </Box>

          <TableContainer sx={{ borderRadius: 2 }}>
            <Table size="small">
              <TableHead sx={{ background: "#0288d1" }}>
                <TableRow>
                  {[
                    "Phone No",
                    "Sender ID",

                    "Status",
                    "Msg Count",
                    "Error Code",
                    "Click Count",
                  ].map((head, idx, arr) => (
                    <TableCell
                      key={head}
                      sx={{
                        color: "#fff",
                        textAlign: "center",
                        fontSize: "0.85rem",
                        borderRight:
                          idx < arr.length - 1 ? "0.5px solid #3a3a3a" : "none",
                      }}
                    >
                      {head}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody sx={{ background: "rgba(255,255,255,0.7)" }}>
                {getClickerCountNumber?.data?.length > 0 ? (
                  getClickerCountNumber.data.map((item, idx) => (
                    <TableRow key={idx} hover>
                      <TableCell
                        align="center"
                        sx={{ borderRight: "0.5px solid #E0E0E0" }}
                      >
                        {showMobileNumber
                          ? item.ph_no
                          : maskPhoneNumber(item.ph_no)}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ borderRight: "0.5px solid #E0E0E0" }}
                      >
                        {item.sender_id}
                      </TableCell>
                      {/* <TableCell
                        align="center"
                        sx={{ borderRight: "0.5px solid #E0E0E0" }}
                      >
                        {item.shortcode}
                      </TableCell> */}
                      <TableCell
                        align="center"
                        sx={{ borderRight: "0.5px solid #E0E0E0" }}
                      >
                        {item.stat}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ borderRight: "0.5px solid #E0E0E0" }}
                      >
                        {item.msgcount || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ borderRight: "0.5px solid #E0E0E0" }}
                      >
                        {item.errcode || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          cursor: "pointer",
                          color: "blue",
                          textDecoration: "underline",
                        }}
                        onClick={() =>
                          handleOpenDetailPopup(item.shortcode, item.ph_no)
                        }
                      >
                        {item.clickcount}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            count={getClickerCountNumber?.totalRecords || 0}
            page={modelPage}
            onPageChange={(e, newPage) => setModelPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(parseInt(e.target.value, 10));
              setModelPage(0);
            }}
            rowsPerPageOptions={[10, 25, 50]}
            sx={{ mt: 1 }}
          />
        </DialogContent>
      </Dialog>

      {/* Actual Numbers Dialog */}
      <Dialog
        open={ActualpopupOpen}
        onClose={handleActualClosePopup}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: "#0288d1",
            color: "#fff",
            fontWeight: 600,
            fontSize: "1.1rem",
          }}
        >
          Actual Numbers
        </DialogTitle>
        <DialogContent sx={{ p: 2 }}>
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              const rows = getActualCount?.data || [];
              if (!rows.length) return;
              const csv = [
                [
                  "Phone No",
                  "Sender ID",
                  "Status",
                  "Msg Count",
                  "Error Count",
                  "Click Count",
                ],
                ...rows.map((r) => [
                  r.ph_no || "",
                  r.sender_id || "",
                  r.stat || "",
                  r.msgcount || "-",
                  r.errcode || "-",
                  r.clickcount ?? 0,
                ]),
              ]
                .map((r) => r.join(","))
                .join("\n");
              const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = `Actual_numbers_${selectedRowId || "data"}.csv`;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
            }}
          >
            ⬇ Download CSV
          </Button>

          <TableContainer component={Paper} sx={{ mt: 1 }}>
            <Table size="small">
              <TableHead sx={{ background: "#0288d1" }}>
                <TableRow>
                  <TableCell
                    sx={{ color: "#fff", borderRight: "0.5px solid #3a3a3a" }}
                  >
                    Phone No
                  </TableCell>
                  <TableCell
                    sx={{ color: "#fff", borderRight: "0.5px solid #3a3a3a" }}
                  >
                    Sender ID
                  </TableCell>
                  <TableCell
                    sx={{ color: "#fff", borderRight: "0.5px solid #3a3a3a" }}
                  >
                    Short Code
                  </TableCell>
                  <TableCell
                    sx={{ color: "#fff", borderRight: "0.5px solid #3a3a3a" }}
                  >
                    Status
                  </TableCell>
                  <TableCell
                    sx={{ color: "#fff", borderRight: "0.5px solid #3a3a3a" }}
                  >
                    Msg Count
                  </TableCell>
                  <TableCell
                    sx={{ color: "#fff", borderRight: "0.5px solid #3a3a3a" }}
                  >
                    Error Code
                  </TableCell>
                  <TableCell sx={{ color: "#fff" }}>Click Count</TableCell>
                </TableRow>
              </TableHead>
              <TableBody sx={{ background: "rgba(255,255,255,0.7)" }}>
                {getActualCount?.data?.length > 0 ? (
                  getActualCount.data.map((item, idx) => (
                    <TableRow key={idx}>
                      <TableCell sx={{ borderRight: "0.5px solid #E0E0E0" }}>
                        {maskPhoneNumber(item.ph_no)}
                      </TableCell>
                      <TableCell sx={{ borderRight: "0.5px solid #E0E0E0" }}>
                        {item.sender_id}
                      </TableCell>
                      <TableCell sx={{ borderRight: "0.5px solid #E0E0E0" }}>
                        {item.shortcode}
                      </TableCell>
                      <TableCell sx={{ borderRight: "0.5px solid #E0E0E0" }}>
                        {item.stat}
                      </TableCell>
                      <TableCell sx={{ borderRight: "0.5px solid #E0E0E0" }}>
                        {item.msgcount || "-"}
                      </TableCell>
                      <TableCell sx={{ borderRight: "0.5px solid #E0E0E0" }}>
                        {item.errcode || "-"}
                      </TableCell>
                      <TableCell>{item.clickcount}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>

      {/* Clicker Details Dialog */}
      <Dialog
        open={detailPopupOpen}
        onClose={handleCloseDetailPopup}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: "#0288d1",
            color: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: 600,
            fontSize: "1.1rem",
          }}
        >
          Clicker Details
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: "#0288d1",
              color: "#fcfcfc",
              fontWeight: 600,
              "&:hover": { backgroundColor: "#e3f2fd" },
            }}
            onClick={async () => {
              try {
                const blob = await downloadClickerReport({
                  shortcode: selectedShortCodeForDetail,
                  type: reportType,
                }).unwrap();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `Clicker_Details_${selectedShortCodeForDetail}_${reportType}.csv`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
              } catch (err) {
                console.error("Download failed", err);
              }
            }}
          >
            ⬇ Download CSV
          </Button>
        </DialogTitle>
        <DialogContent sx={{ p: 2 }}>
          <TableContainer component={Paper} sx={{ mt: 1 }}>
            <Table size="small">
              <TableHead sx={{ background: "#0288d1" }}>
                <TableRow>
                  {[
                    "Phone No",
                    "Device Name",
                    "OS Name",
                    "Browser Name",
                    "Client IP",
                    "Click Time",
                    "Status",
                  ].map((head, idx, arr) => (
                    <TableCell
                      key={head}
                      sx={{
                        color: "#fff",
                        textAlign: "center",
                        fontSize: "0.85rem",
                        borderRight:
                          idx < arr.length - 1 ? "0.5px solid #3a3a3a" : "none",
                      }}
                    >
                      {head}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody sx={{ background: "rgba(255,255,255,0.7)" }}>
                {isDetailsLoading ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      Loading details...
                    </TableCell>
                  </TableRow>
                ) : (clickerDetailsData?.data || []).filter(
                    (item) =>
                      !selectedPhoneForDetail ||
                      item.ph_no === selectedPhoneForDetail,
                  ).length > 0 ? (
                  clickerDetailsData.data
                    .filter(
                      (item) =>
                        !selectedPhoneForDetail ||
                        item.ph_no === selectedPhoneForDetail,
                    )
                    .map((item, idx) => (
                      <TableRow key={idx} hover>
                        <TableCell
                          align="center"
                          sx={{ borderRight: "0.5px solid #E0E0E0" }}
                        >
                          {showMobileNumber
                            ? item.ph_no
                            : maskPhoneNumber(item.ph_no)}{" "}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ borderRight: "0.5px solid #E0E0E0" }}
                        >
                          {item.device_name}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ borderRight: "0.5px solid #E0E0E0" }}
                        >
                          {item.os_name}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ borderRight: "0.5px solid #E0E0E0" }}
                        >
                          {item.browser_name}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ borderRight: "0.5px solid #E0E0E0" }}
                        >
                          {item.client_ip}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ borderRight: "0.5px solid #E0E0E0" }}
                        >
                          {item.click_time}
                        </TableCell>
                        <TableCell align="center">{item.stat}</TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>

      {/* Clicker Click List Dialog */}
      <Dialog
        open={clickListPopupOpen}
        onClose={handleCloseClickListPopup}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            width: "850px",
            maxWidth: "95vw",
            
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#0288d1",
            color: "#fff",
            fontWeight: 600,
            fontSize: "1.1rem",
          }}
        >
          {reportType === "actual" ? "Actual Click List" : "All Click List"}
        </DialogTitle>

        <DialogContent sx={{ p: 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mb: 1,
            }}
          >
            <Button
              variant="contained"
              size="small"
              onClick={async () => {
                try {
                  const result = await downloadClickerClickList({
                    clicker_campaign_id: selectedRowId,
                    type: reportType,
                  }).unwrap();

                  if (result?.status === false) {
                    toast.error(result?.message || "No data found");
                    return;
                  }

                  const url = window.URL.createObjectURL(result);
                  const a = document.createElement("a");

                  a.href = url;
                  a.download = `Clicker_Click_List_${reportType}_${selectedRowId}.csv`;

                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);

                  window.URL.revokeObjectURL(url);

                  toast.success("Click list downloaded successfully");
                } catch (err) {
                  console.error("Download Error:", err);
                  toast.error(
                    err?.data?.message || "Failed to download click list",
                  );
                }
              }}
            >
              ⬇ Download CSV
            </Button>
          </Box>
          <TableContainer component={Paper} sx={{ mt: 1 }}>
            <Table size="small">
              <TableHead sx={{ background: "#0288d1" }}>
                <TableRow>
                  {[
                    "Phone No",
                    "Status",
                    "Device",
                    "OS",
                    "Browser",
                    "Client IP",
                    "Click Time",
                  ].map((head, idx, arr) => (
                    <TableCell
                      key={head}
                      sx={{
                        color: "#fff",
                        textAlign: "center",
                        fontSize: "0.85rem",
                        borderRight:
                          idx < arr.length - 1 ? "0.5px solid #3a3a3a" : "none",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {head}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody sx={{ background: "rgba(255,255,255,0.7)" }}>
                {isClickListLoading ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      Loading...
                    </TableCell>
                  </TableRow>
                ) : clickerClickListData?.data?.length > 0 ? (
                  clickerClickListData.data.map((item, idx) => (
                    <TableRow key={idx} hover>
                      <TableCell
                        align="center"
                        sx={{ borderRight: "0.5px solid #E0E0E0" }}
                      >
                        {showMobileNumber
                          ? item.ph_no
                          : maskPhoneNumber(item.ph_no)}
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{ borderRight: "0.5px solid #E0E0E0" }}
                      >
                        {item.stat || "-"}
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{ borderRight: "0.5px solid #E0E0E0" }}
                      >
                        {item.device_name || "-"}
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{ borderRight: "0.5px solid #E0E0E0" }}
                      >
                        {item.os_name || "-"}
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{ borderRight: "0.5px solid #E0E0E0" }}
                      >
                        {item.browser_name || "-"}
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{ borderRight: "0.5px solid #E0E0E0" }}
                      >
                        {item.client_ip || "-"}
                      </TableCell>

                      <TableCell align="center">
                        {item.click_time
                          ? new Date(item.click_time).toLocaleString("en-GB")
                          : "-"}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            count={clickerClickListData?.totalRecords || 0}
            page={clickListPage}
            onPageChange={(e, newPage) => setClickListPage(newPage)}
            rowsPerPage={clickListRowsPerPage}
            onRowsPerPageChange={(e) => {
              setClickListRowsPerPage(parseInt(e.target.value, 10));
              setClickListPage(0);
            }}
            rowsPerPageOptions={[10, 25, 50, 100]}
            sx={{ mt: 1 }}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ManageCampaign;
